import { Clipboard } from '@angular/cdk/clipboard';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ChangeCommissionModalComponent } from 'src/app/components/change-commission-modal/change-commission-modal.component';
import { AffiliateModalComponent } from 'src/app/components/profile/affiliate-modal/affiliate-modal.component';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-user-profile-affiliate-page',
  templateUrl: './user-profile-affiliate-page.component.html',
  styleUrls: ['./user-profile-affiliate-page.component.scss'],
})
export class UserProfileAffiliatePageComponent implements OnInit {
  constructor(
    private api: UserApiService,
    private clipboard: Clipboard,
    private message: MessageService,
    private dialog: MatDialog
  ) {
  }
  affiliate: any;
  loading = false;

  ngOnInit(): void {
    this.getUserAffiliate();
  }

  async getUserAffiliate() {
    try {
      this.loading = true;
      const r = await this.api.getUserAffiliate();
      this.affiliate = r.data;
    } catch (error) {
    } finally {
      this.loading = false;

      if (this.affiliate.is_partner && !this.affiliate.is_marked)
        this.dialog.open(AffiliateModalComponent, {
          panelClass: 'affiliateModal',
        });

      if (this.affiliate.is_partner && !this.affiliate.show_promo_popup)
        this.dialog.open(ChangeCommissionModalComponent, {
          width: '519px',
          panelClass: 'change-modal',
        });
    }
  }
}
